/**=========================================================
 * Module: app-offer.js
 * Handles analysis
 =========================================================*/

App.directive('appOffer', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/offer.html',
      restrict: 'E',
      replace: true,
      controller: 'OfferController',
      scope: { 
          analysis: '=analysis',
          project: '=project',
          dest: '=dest'
      }
  };

});
